const Experience = ({ data }) => {
  return (
    <div
      className="row text-center wow bounceIn animated"
      data-wow-duration="1s"
      data-wow-delay=".2s"
    >
      <div className="col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 text-center mb-4">
        <h1>EXPERIENCE</h1>
      </div>
      <div
        className="wow bounceIn animated exp-content"
        data-wow-duration="1s"
        data-wow-delay=".4s"
      >
        {data.workExperience.map((work, idx) => (
          <div className="col-lg-3 col-md-3 col-sm-4 col-xs-12 mb-3" key={idx}>
            <div className="portfolio-sec-wrap">
              <img
                className="img-responsive"
                src={
                  work.companyLogo ||
                  "https://www.kindpng.com/picc/m/179-1791617_microsoft-office-save-icon-office-symbol-black-and.png"
                }
                alt={work.companyName}
              />
              <div className="overlay">
                <div className="portfolio-sec-inner">
                  <h3>
                    <a href={work.companyLink}>{work.companyName}</a>
                  </h3>

                  <span>{work.position}</span>
                  <p>
                    {work.startDate}-{work.endDate}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default Experience;
